import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResponseTranslation, TranslationLangKey } from '../models/Translations';

@Injectable({ providedIn: 'root' })
export class LocaleHelperService {
  constructor(private translateService: TranslateService) {}

  getLocalizedValue(value: ResponseTranslation | null | undefined): string {
    if (!value) return '';

    const lang =
      (this.translateService.currentLang as TranslationLangKey) || (this.translateService.getDefaultLang() as TranslationLangKey);

    return value[lang] || value.en || '';
  }
}
